module.exports = __webpack_public_path__ + "img/icon-list-view.4cf8c5ef.svg";